import { Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addEquipoRadiologico } from "../../../../../../../../redux/actions/resolucion";
import FormikActions from "../../../../../../../commons/formik/FormikActions";
import TabsWithErrors, { TabPanel } from "../../../../../../../commons/tab/tabWithError/TabsWithErrors";
import { StyledResolucion } from "../../../../../../../styled/Prevencion";
import { validateAddEquipoRadiologico } from "../../../formValidations";
import EquipoRadiologicoFormContainer from "./equipoRadiologicoForm/equipoRadiologicoFormContainer";
import DosimetriaTableContainer from "./tabs/dosimetria/DosimetriaTableContainer";
import ProtRadTableContainer from "./tabs/proteccionRadiologica/ProtRadTableContainer";
import ResponsableInstalacionTableContainer from "./tabs/responsableInstalacion/ResponsableInstalacionTableContainer";
import ResponsableUsoTableContainer from "./tabs/responsableUso/ResponsableUsoTableContainer";

// La mayoria de los valores se guardan en redux (la variable formValues contiene todos)
const initialValues = {
  equipoRadiologico: "",
};

const EquipoRadiologicoTabs = ({ handleGoBack, stepper }) => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.resolucion.abmEquiposRadiologicos)
  const [tabIndex, setTabIndex] = useState(0);

  const [values, setValues] = useState(initialValues);
  const ref = useRef();

  // useScrollIntoViewOnRender(ref, 'start')  ROMPE
  useEffect(() => {
    if (formValues.idTabla !== null) {
      setValues({
        equipoRadiologico: formValues.equipoRadiologicoData.modelo
      })
    } else {
      setValues(initialValues)
    }
  }, [formValues.idTabla])


  const [errores, setErrores] = useState({});


  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const addEquipoRadiologicoValidation = () => {
    let errores = {};
    if (formValues.dosimetria.length === 0) {
      errores.dosimetria = "Se requiere agregar al menos una Dosimetria";
    }
    if (formValues.respUso.length === 0) {
      errores.respUso = "Se requiere agregar al menos un Responsable de Uso";
    }
    if (formValues.respInst.length === 0) {
      errores.respInst = "Se requiere agregar al menos un Responsable de Instalación";
    }
    if (formValues.protRad.length === 0) {
      errores.protRad = "Se requiere agregar al menos un Encargado de Protección Radiológica";
    }
    return errores
  }

  const handleAddEquipoRadiologico = (values) => {
    const errores = addEquipoRadiologicoValidation();
    // Toast de errores para los tabs
    if (Object.keys(errores).length > 0) {
      Object.keys(errores).forEach((v) => {
        toast.error(errores[v]);
      })
      setErrores(errores);
      return;
    }

    let { idTabla, ...finalValues } = formValues;

    dispatch(addEquipoRadiologico(finalValues, idTabla));
    handleGoBack();
  };


  return (
    <>
      <Formik
        initialValues={values}
        enableReinitialize={true}
        onSubmit={handleAddEquipoRadiologico}
        validationSchema={validateAddEquipoRadiologico}
      >
        <Form>
          <>
            <Grid item xs={12} container>
              <StyledResolucion.PaddingContainer item xs={6}>
                <Typography variant="h5" ref={ref}>Equipo Radiológico</Typography>
                <EquipoRadiologicoFormContainer
                />
              </StyledResolucion.PaddingContainer>
            </Grid>
            <Grid container>
              {/* Sección de los tabs */}
              <Grid item xs={2}>

                <TabsWithErrors
                  handleTabChange={handleTabChange}
                  tabIndex={tabIndex}
                  tabs={[
                    { label: "DOSIMETRÍA", id: "dosimetria" },
                    { label: "RESP. USO", id: "respUso" },
                    { label: "RESP. INSTALACIÓN", id: "respInst" },
                    { label: "PROT. RADIOLÓGICA", id: "protRad" }
                  ]}
                  errors={errores}
                />

              </Grid>

              {/* Sección de la tabla */}
              <Grid item xs={10}>
                <TabPanel value={tabIndex} index={0}>
                  <DosimetriaTableContainer />
                </TabPanel>


                <TabPanel value={tabIndex} index={1}>
                  <ResponsableUsoTableContainer />
                </TabPanel>

                <TabPanel value={tabIndex} index={2}>
                  <ResponsableInstalacionTableContainer />
                </TabPanel>

                <TabPanel value={tabIndex} index={3}>
                  <ProtRadTableContainer />
                </TabPanel>
              </Grid>
            </Grid>
            {stepper ?? ""}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <FormikActions
                submit="Aceptar"
                handleCancel={handleGoBack}
                cancel="Cancelar"
              />
            </div>
          </>
        </Form>
      </Formik>

    </>
  );
};

export default EquipoRadiologicoTabs;
